<template>
  <div
    class="cbg-white-container v-card border-card input-container theme--light"
  >
    <div class="col-sm-12 row ml-0 pl-0 pr-0">
      <div class="form-group col-sm-6 col-md-3">
        <label for>Filter</label>
        <div class="search-div position-relative">
          <input
            type="number"
            placeholder="Search"
            class="form-control"
            v-model="searchLog"
            @input="debounceSearch"
          />
          <div
            v-if="searchLog !== ''"
            class="search-svg position-absolute"
            @click="clearSearch()"
          >
            <crossSVG />
          </div>
        </div>
      </div>
    </div>
    <div class="table-div">
      <table class="table">
        <tr>
          <th>Mobie</th>
          <th>response</th>
          <th>Message</th>
          <th>Status</th>
        </tr>
        <tbody v-for="(item, index) in logArray" :key="index">
          <tr>
            <td>{{ item.mobile }}</td>
            <td>{{ item.response }}</td>
            <td>{{ item.message }}</td>
            <td>
              {{
                item.status == 1
                  ? "Success"
                  : item.status == 2
                  ? "Failed"
                  : "Pending"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination
      v-if="!isEmpty"
      class="mx-4 mob-t-center pagination-block"
      :recordPerPage="record_per_page"
      :total="total"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import _ from "lodash";
export default {
  name: "LogDetails",
  data() {
    return {
      logArray: [],
      searchLog: "",
      isEmpty: false,
      record_per_page: 10,
      total: 0,
      currentPage: 1,
    };
  },
  mounted() {
    this.fetchLogs();
  },
  components: {
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination"),

  },

  methods: {

    changePage(page = { currentPage: 1, reduced: false }, reset = false) {
      if (reset) {
        page = { currentPage: 1, reduced: false }
      }
      if (!page.reduced) {
        this.currentPage = page.currentPage;
        this.debounceSearch();
      } else {
        this.currentPage = 1;
      }
    },
    clearSearch() {
      this.searchLog = "";
    },
    fetchLogs() {
      let url = `${config.TRANSPORT_URL}sms-logs?mobile=${this.searchLog}&page=${this.currentPage}`;
      this.$http.get(url).then((res) => {
        if (res.status) {
          if (res && res.data && res.data && res.data.list.length) {
            this.logArray = res.data.list;
            this.isEmpty = false;
          } else {
            this.logArray = [];
            this.isEmpty = true;
          }
          this.currentPage = res.data.page;
          this.total = res.data.count;
        } else {
          this.logArray = [];
          this.isEmpty = true;
        }
      });
    },
    debounceSearch: _.debounce(function (e) {
      this.fetchLogs();
    }, 1000),
  },
};
</script>
